import { render, staticRenderFns } from "./TradeDashboard.vue?vue&type=template&id=7881cb48&scoped=true&"
import script from "./TradeDashboard.vue?vue&type=script&lang=js&"
export * from "./TradeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TradeDashboard.vue?vue&type=style&index=0&id=7881cb48&lang=scss&scoped=true&"
import style1 from "./TradeDashboard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881cb48",
  null
  
)

export default component.exports